import { Node } from "@xyflow/react";
import { TFunction } from "i18next"; // Import TFunction

import { DecisionConfirmationTypes } from "@/pages/Private/pages/Course/enums/DecisionConfirmationTypes.enum"; // Pfad ggf. anpassen
import { FileTypes } from "@/pages/Private/pages/Courses/enums/FileTypes.enum";
import { PhaseEndResult } from "@/pages/Private/pages/Courses/enums/PhaseEndResult.enum"; // Pfad ggf. anpassen

import { PhaseEffect } from "../../enums/PhaseEffect.enum";

// XYPosition definieren und exportieren, damit es überall konsistent genutzt werden kann
export type XYPosition = {
	x: number;
	y: number;
};

interface IDecisionOption {
	option: string;
	phaseId: number | null; // Phase ID darf nicht null sein
	position?: XYPosition; // XYPosition hier verwenden
}

export type PhaseData = {
	id: number;
	avatar?: { id: string | null; url: string | null };
	courseId: number;
	content: string;
	autoplay?: boolean;
	large?: boolean;
	phaseName: string;
	contentType: FileTypes;
	timeLimit?: number;
	decisionName?: string;
	decisionOptions?: IDecisionOption[];
	requireExplanation?: boolean;
	spoilerContent?: {
		title: string;
		content: string;
	};
	timeDelayedContent?: {
		title: string;
		content: string;
		autoplay?: boolean;
		contentType: FileTypes;
		startTimeInSeconds: number | null;
		endTimeInSeconds: number | null;
		large?: boolean;
	}[];
	// json: Record<string, unknown>[];
	timeLeftDecisionId?: number;
	confirmationRequired?: DecisionConfirmationTypes;
	phaseEndText?: string;
	phaseEndResult: PhaseEndResult;
	effects: PhaseEffect[];
	// Position ist hier **nicht optional**
	position: XYPosition;
	// deleteNode?: (id: string | number) => void;
};

// Typ für einen Node, der PhaseData nutzt
export type PhaseNodeData = Node<PhaseData, "phaseNode">;

// Modify createDefaultPhaseData to accept the t function
export function createDefaultPhaseData(
	t: TFunction, // Add t function as a parameter
	courseId: number,
	overrides: Partial<PhaseData> = {}
	// deleteNode?: (id: string | number) => void
): PhaseData {
	return {
		id: 0,
		courseId,
		content: "",
		phaseName: "",
		contentType: FileTypes.Text,
		autoplay: false,
		decisionName: undefined,
		decisionOptions: undefined,
		confirmationRequired: undefined,
		timeLeftDecisionId: undefined,
		timeDelayedContent: [],
		phaseEndText: "",
		// json: [],
		phaseEndResult: PhaseEndResult.Success,

		// Default-Position, damit neue Nodes nicht übereinanderliegen
		position: { x: 100, y: 100 },
		effects: [],
		// deleteNode,
		...overrides,
	};
}
